import { useEffect, useContext, useState } from "react";
import PropTypes from "prop-types";
import INFRAMARK_CONSTANTS from "common/Constants/inframark-constants";
import UserContext from "common/Context/UserContext";
import CustomAlert from "common/Components/CustomAlert";
import "./ThingTypeList.styles.css";
import { clearCustomerContextHeaders } from "common/HttpClient/CustomerContextHeaders";

const ThingTypeList = ({
  thingTypes,
  handleAddNewThingType,
  handleEditAssetTypeStatus,
  handleEditThingType,
  fetchAllThingTypes,
  handlePreviewThingType,
  handleSearchThingType,
}) => {
  const { constants, tableHeaders } = INFRAMARK_CONSTANTS.thingTypeDetails;
  const { userProfile } = useContext(UserContext);
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertInfo, setAlertInfo] = useState({});
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const selectedCustomer = localStorage.getItem("selected_customer");
    if (selectedCustomer) {
      localStorage.removeItem("selected_customer");
    }
    clearCustomerContextHeaders();
    if (thingTypes === null) {
      fetchAllThingTypes();
    }
  }, [thingTypes, fetchAllThingTypes]);

  const handleThingTypeStatus = (isActive, thingtypeId) => {
    let info = { modifiedBy: userProfile.profile.userid };
    const title = isActive ? "Activate AssetType" : "Deactivate AssetType";
    const message = isActive
      ? "Are you sure you want to activate this asset type?"
      : "Are you sure you want to deactivate this asset type? This will affect all associated data.";
    const action = handleEditAssetTypeStatus;
    info["thingTypeId"] = thingtypeId;
    info["isActive"] = isActive;
    setAlertInfo({ title, message, action, info });
    setAlertVisible(true);
  };

  return (
    <div className="admin-panel">
      <div className=" header-user" style={{ padding: "0px 0px 16px 8px" }}>
        <div className="col-6 actions" style={{ padding: 0 }}>
          <h4 className="h4-title-size">Asset Type List</h4>
        </div>

        <div class="input-group col-3" style={{ paddingRight: 0 }}>
          <input
            class="form-control py-2 border-right-0 border search-asset-list"
            type="search"
            placeholder="search asset"
            id="search-input"
            autoComplete="off"
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              if (e.target.value.length === 0) {
                handleSearchThingType("");
              }
            }}
          />
          <span class="input-group-append">
            <button
              class="btn btn-outline-secondary border-left-0 border"
              type="button"
              onClick={() => {
                handleSearchThingType(searchQuery);
              }}
            >
              <i class="bi bi-search"></i>
            </button>
          </span>
        </div>
      </div>
      <div
        className="col-12 row"
        style={{ padding: "0px", paddingBottom: "16px", display: "none" }}
      >
        <div className="col-4">
          <button
            style={{ marginLeft: "0" }}
            className="add-new add-new-bg"
            onClick={() => {
              handleAddNewThingType(constants.ADDTHINGTYPEVIEW);
            }}
          >
            <i className="bi bi-plus-circle"></i> Add New Asset Type
          </button>
        </div>
      </div>
      {alertVisible && (
        <CustomAlert
          show={alertVisible}
          title={alertInfo.title}
          okText={alertInfo.info.isActive ? "ACTIVATE" : "DEACTIVATE"}
          onOkay={() => {
            alertInfo.action(alertInfo.info);
            setAlertVisible(false);
          }}
          onCancel={() => {
            setAlertVisible(false);
            setAlertInfo({});
          }}
          message={alertInfo.message}
        />
      )}
      <table>
        <thead>
          <tr>
            {tableHeaders.thingType.map((title) => (
              <th key={title}>{title}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {thingTypes
            ?.sort((a, b) => a.thingTypeId - b.thingTypeId)
            .map((thingtype) => (
              <tr key={thingtype.thingTypeId}>
                <td>
                  <button
                    style={{ color: "#1A6BE8" }}
                    aria-label="previewThingType"
                    className="edit-button"
                    onClick={() => {
                      handlePreviewThingType(thingtype);
                    }}
                  >
                    {thingtype.thingType}
                  </button>
                </td>
                <td>{thingtype.displayPage}</td>
                <td className="toggle ">
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={thingtype.thingTypeIsActive}
                      onChange={(e) => {
                        handleThingTypeStatus(
                          e.target.checked,
                          thingtype.thingTypeId
                        );
                      }}
                    />
                    {""}
                    <span className="slider"></span>
                  </label>
                </td>
                <td className="text-td-alignment" style={{ display: "none" }}>
                  <button
                    aria-label="editThingType"
                    className="edit-button"
                    onClick={() => {
                      handleEditThingType(thingtype);
                    }}
                  >
                    <i
                      className="bi bi-pencil-fill"
                      style={{ color: "#1A6BE8" }}
                    ></i>
                  </button>
                  {/* <button aria-label="previewThingType" className="edit-button" onClick={() => { handlePreviewThingType(thingtype) }}>
                  <i className="bi bi-eye-fill"></i>
                </button> */}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default ThingTypeList;

ThingTypeList.propTypes = {
  thingTypes: PropTypes.array,
  handleAddNewThingType: PropTypes.func.isRequired,
  handleEditAssetTypeStatus: PropTypes.func.isRequired,
  handleEditThingType: PropTypes.func.isRequired,
  fetchAllThingTypes: PropTypes.func.isRequired,
  handlePreviewThingType: PropTypes.func.isRequired,
};
